import React, { useEffect, useState } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserCard from '../../components/UserCard';
import Loader from '../../components/Loader';
import { useParams } from 'react-router-dom';
import "./user.css"

const UserFollowings = () => {
    const [userFollowings, setUserFollowings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false)
    const [page, setPage] = useState(1)
    const [isFriend, setIsFriend] = useState(null)
    const [isFollowing, setIsFollowing] = useState(null)

    const { user } = useParams()

    useEffect(() => {
        const checkIsFriend = async () => {
            try {
                const response = await api.get(`/users/${user}/check`)
                if (response) {
                    setIsFriend(response.data)
                }
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }
        checkIsFriend()
    }, [user])

    useEffect(() => {
        const getUserFollowings = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/users/${user}/followings`, { params: { page } });
                setUserFollowings(response.data.followings);

                if (response.data.followings.length < 20) {
                    setHasMore(false)
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to fetch followings");
            } finally {
                setIsLoading(false);
            }
        };

        getUserFollowings();
    }, [page, user]);

    const handleRefresh = async () => {
        setPage(1)
        setUserFollowings([])
    }

    const sendFollowRequest = async (id) => {
        try {
            const response = await api.post()
        } catch (error) {

        }
    }
    const sendUnfollowRequest = async (id) => {
        try {
            console.log(id)
        } catch (error) {

        }
    }

    return (
        <div className='users-page-container'>
            <div className="userfriends-header">
                <h3>Followings</h3>
                {isFriend && <button className="add-frd-btn" onClick={() => sendUnfollowRequest(user)}>unfollow</button>}
                {!isFriend && <button className="add-frd-btn" onClick={() => sendFollowRequest(user)}>follow</button>}
            </div>
            <InfiniteScroll
                dataLength={userFollowings.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="friends-list">
                    {
                        isLoading && <Loader />
                    }
                    {!isLoading && userFollowings.length === 0 &&
                        <p className="not-found-msg">Not following anyone</p>
                    }
                    {
                        userFollowings && userFollowings.map((frd) => (
                            <UserCard user={frd} />
                        ))
                    }
                </div>
            </InfiniteScroll>
        </div>
    );
};

export default UserFollowings;
